import { render } from "./cadastro_revisao.vue?vue&type=template&id=228386ca&scoped=true"
import script from "./cadastro_revisao.vue?vue&type=script&lang=js"
export * from "./cadastro_revisao.vue?vue&type=script&lang=js"

import "./cadastro_revisao.vue?vue&type=style&index=0&id=228386ca&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228386ca"]])

export default __exports__